import { Navigate } from 'react-router-dom';

import LoadingOverlay from '../../components/common/LoadingOverlay/LoadingOverlay';
import React from 'react';
import { useCapabilityAccess } from '../../hooks/useCapabilityAccess';

interface DmsOperatorGuardProps {
  children: React.ReactNode;
}

/**
 * Data Reception is a normal Operator surface; internal observability access
 * (support staff without a DMS group role) can still reach it too, since the
 * page's own Technical Diagnostics tab stays separately gated on that
 * capability. UI hiding is presentation only - the backend independently
 * enforces scope on every request.
 */
const DmsOperatorGuard: React.FC<DmsOperatorGuardProps> = ({ children }) => {
  const access = useCapabilityAccess();

  if (!access.initialized) {
    return <LoadingOverlay visible />;
  }

  if (!access.canUseDmsOperatorFeatures && !access.canAccessInternalObservability) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default DmsOperatorGuard;
